import { Button, Subhead } from "@growtherapy/sprout-ui";
import { Navbar, PageContainer, PageProviders } from "../../components";
import { Theme } from "../../state";
import { useGetTelehealthSessionInfo } from "../../hooks";
import { useParams } from "react-router-dom";
import ChairAndArmchair from "../../assets/chair-and-armchair.svg";
import { useAtomValue } from "jotai";
import { visitorNameAtom, VisitorState, visitorStateAtom } from "../state";
import { useEnterWaitingRoomCallback } from "../nav/useEnterWaitingRoomCallback";

export type RejoinPageProps = {
  providerName: string;
  isTimeout: boolean;
  onRejoin: () => void;
};

export function Page({
  providerName,
  isTimeout,
  onRejoin,
}: {
  onRejoin: () => void;
  providerName: string;
  isTimeout: boolean;
}) {
  const timeOutMessage = isTimeout
    ? `👋  Looks like you’ve been waiting for ${providerName} for a while. If your session is still taking place, please rejoin the waiting room.`
    : `👋  You navigated away from the waiting room of ${providerName}. If your session is still taking place, please rejoin the waiting room.`;

  return (
    <PageProviders theme={Theme.LIGHT}>
      <PageContainer>
        <Navbar />
        <div className="border-t bg-neutral-200 h-full">
          <div className="px-6 flex flex-col items-center justify-center gap-4">
            <img
              src={ChairAndArmchair}
              alt=""
              className="max-w-full pt-10 rebrand:hidden"
            />
            <Subhead.Default
              as="h1"
              className="font-medium text-medium text-center max-w-[40rem] pt-4 rebrand:font-normal rebrand:text-large rebrand:pt-16 rebrand:pb-4"
            >
              {timeOutMessage}
            </Subhead.Default>
            <Button className="w-full sm:w-auto" onClick={onRejoin}>
              Rejoin waiting room
            </Button>
          </div>
        </div>
      </PageContainer>
    </PageProviders>
  );
}

export function PageWrapper() {
  const { providerShortId, patientShortId } = useParams();
  const { data } = useGetTelehealthSessionInfo(providerShortId, patientShortId);
  const visitorState = useAtomValue(visitorStateAtom);
  const enterWaitingRoom = useEnterWaitingRoomCallback();
  const visitorName = useAtomValue(visitorNameAtom);

  return (
    <Page
      providerName={
        data?.telehealthSessionInfo?.provider.name ?? "your provider"
      }
      isTimeout={visitorState === VisitorState.TIMEOUT}
      onRejoin={() => {
        enterWaitingRoom(visitorName);
      }}
    />
  );
}
